import React from "react";
import { Col, FormLabel, Row } from "react-bootstrap";
import { labels } from "../../../../localization/labels";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SubmitButton from "../../../core/SubmitButton";
import CommonUtil from "../../../../utils/CommonUtil";
import { constants } from "../../../../utils/Constants";

export const calcSearchSimilar = (entity, propertiesNames) => {
  let entitySimilarSearch = {};
  let propertiesLength = 0;

  propertiesNames.forEach(property => {
    const value = CommonUtil.getDeep(entity, property);
    entitySimilarSearch = { ...entitySimilarSearch, [property]: value };
    propertiesLength += CommonUtil.getSafeStringLength(value);
  });

  return {
    searchSimilar: propertiesLength >= constants.MIN_SEARCH_SIMILAR_LENGTH,
    entitySimilarSearch
  };
};

export const calcKnowledgeItemSearchSimilar = entity => {
  return calcSearchSimilar(entity, ["name", "description", "descriptionUsage"]);
};

const SearchSimilar = props => {
  const similarEntity = props.similarEntity;

  return similarEntity ? (
    <Row>
      <Col sm={props.isInDialog ? "3" : "2"} xs={props.isInDialog ? "" : "3"}>
        <FormLabel className="Label">{labels.similarKnowledgeItem}</FormLabel>
      </Col>
      <Col sm={props.isInDialog ? "7" : "8"} xs={props.isInDialog ? "10" : "7"}>
        <SubmitButton
          type="link"
          onClick={props.openInNewTab}
          disabled={props.isLoading}
          size="sm"
          className="link-text"
          text={similarEntity.id + " - " + similarEntity.name}
          openInNewTab={props.openInNewTab}
        ></SubmitButton>
      </Col>
      <Col sm="2" xs="2" className="iconTextAlign">
        {props.isLoading ? (
          <FontAwesomeIcon color="orange" size="lg" icon={faClock} />
        ) : // <Button size="xs" title={labels.moreLabel}>
        //   <FontAwesomeIcon icon={faSearchPlus} />
        // </Button>
        null}
      </Col>
    </Row>
  ) : null;
};

export default SearchSimilar;
